export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const DUPLICATE_ITEM = 'DUPLICATE_ITEM'
export const EMPTY_CART = 'EMPTY_CART'
